import { styled as r } from "styled-components";
import { Body as i, Caption as l } from "../../styles/typography/index.js";
import { Colors as e } from "../../styles/colors/index.js";
import { MediaQuery as n } from "../../styles/variables.js";
import { Theme as o } from "../../styles/themes/index.js";
const m = r.div`
  ${i}
  position: relative;
  border-radius: 8px;
  padding: 10px 12px 10px 12px;
  width: 100%;
  min-height: 40px;
  background: rgb(${o.colors.Juliet});
  border: 1px solid rgb(${o.colors.Golf});
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &[data-focused='true'] {
    border: 1px solid rgb(${o.colors.Alpha});
    min-height: 180px;
  }

  @media ${n.SCREEN_MD_UP} {
    padding: 12px;
    &:focus-within {
      min-height: 245px;
    }
  }
`, b = r.div`
  & {
    border: none !important; // force orverride quill style
    padding: 0;
    height: auto !important;
  }

  &.ql-snow .ql-editor,
  .ql-editor {
    padding: 0;
    ${l}

    & > * + * {
      margin-top: 0.75em;
    }

    &::before {
      left: 0 !important; // force orverride quill style
      font-style: unset !important; // force orverride quill style
      color: rgb(${e.Gray}) !important; // force orverride quill style
    }

    a {
      color: inherit;
      text-decoration: none;

      &.custom-link {
        color: rgb(
          ${o.colors.Brand}
        ) !important; // force orverride quill style
        text-decoration: underline;
      }
    }

    img {
      max-width: 100%;
      height: auto;
      border-radius: 4px;
      display: block;
    }

    ul li {
      list-style-type: disc;
    }

    ul,
    ol {
      padding: 0 1rem;
      li {
        padding-left: 0;
        &::before {
          content: none;
        }

        ${Array(9).fill("").map(
  (d, t) => `
          
          &.ql-indent-${t} {
            margin-left: ${t}rem;
            padding-left: 0;
          }
        `
)}
      }
    }
  }

  .ql-tooltip {
    display: none;
  }

  .ql-clipboard {
    position: fixed !important;
    opacity: 0 !important;
    left: 50% !important;
    top: 50% !important;
  }
`, f = r.button`
  #toolbar && {
    border-radius: 4px;
    width: 24px;
    height: 24px;
    font-size: 24px;
    background: transparent;
    padding: 0;
    color: rgb(${o.colors.Alpha});

    &:disabled {
      color: rgb(${e.Gray});
      &:hover {
        color: rgb(${e.Gray});
      }
    }

    &[aria-pressed='true'],
    &[aria-pressed='true']:hover,
    &[aria-pressed='true']:focus {
      background-color: rgb(${o.colors.Brand});
      color: rgb(${e.White});
    }

    &:hover,
    &:focus {
      color: inherit;
    }
  }
`, u = r.div`
  &#toolbar {
    display: flex;
    align-items: center;
    justify-content: start;
    gap: 0 12px;
    padding: 0;
    border: none;

    border-top: 1px solid rgb(${o.colors.Golf});
    margin-top: 8px;
    padding-top: 8px;
    overflow-y: hidden;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }

    &[aria-hidden='true'] {
      display: none;
    }
  }
`, h = r.div`
  height: 20px;
  min-width: 1px;
  background: rgb(${o.colors.Golf});
`;
export {
  m as Container,
  h as ControlsDivider,
  b as Editor,
  u as Toolbar,
  f as ToolbarButton
};
